import React from 'react';
import { Menu } from 'antd';
import { useLocation } from 'react-router-dom';
import { HorizontalMenuWrapper } from './style';
import { menuConfig } from '../utility/menuList';

const TopMenu = ({ darkMode }) => {
    const location = useLocation();
    const currentMenu = menuConfig.customer_care;
    
    // Match the current active menu key based on route path
    const matchedKey = currentMenu.find(item => 
        location.pathname.toLowerCase().startsWith('/' + item.key)
    )?.key || 'dashboard';

    return (
        <HorizontalMenuWrapper darkMode={darkMode} style={{ width: '100%' }}>
            <Menu 
                mode="horizontal" 
                selectedKeys={[matchedKey]} 
                items={currentMenu} 
                className="top-menu" 
                style={{ width: '90%' }} 
            />
        </HorizontalMenuWrapper>
    );
};

export default TopMenu;
